import getCanvas from '../helpers/getCanvas';

const inputImageToButton = (html) => {
  const canvas = getCanvas(html);
  const inputImage = canvas.querySelector('input[type="image"]');
  const button = document.createElement('button');

  if (!inputImage) {
    return html;
  }

  button.setAttribute('type', 'submit');
  button.innerHTML = inputImage.getAttribute('alt');

  inputImage.insertAdjacentHTML('afterEnd', button.outerHTML);
  inputImage.remove();

  return canvas.innerHTML;
};

export default inputImageToButton;



/** WEBPACK FOOTER **
 ** ./src/helpers/form/filters/factories/inputImageToButton.js
 **/